import React from 'react'

interface V3PageBridgeFrameProps {
  children: React.ReactNode
}

export default function V3PageBridgeFrame({ children }: V3PageBridgeFrameProps) {
  return (
    <div className="min-w-0 bg-[#F9FAFB] text-gray-900">
      {children}
    </div>
  )
}

